import styled, { css } from 'styled-components';
import { hover } from 'src/components/utils';

export const PrimaryButton = styled.button(
  ({ theme }) => css`
    ${theme.typography.button.l};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: ${theme.sz.s};
    min-height: ${theme.sz.s14};
    padding: ${theme.sz.s3} ${theme.sz.s6};
    border: 0;
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.primary20};
    color: ${theme.co.neutral10};
    cursor: pointer;

    &:hover:not(:disabled) {
      background-color: ${hover(theme.co.primary20)};
    }

    &:disabled {
      background-color: ${theme.co.neutral95};
      color: ${theme.co.neutral40};
      cursor: default;
    }

    @media (max-width: ${theme.sz.md}) {
      max-width: none;
      min-height: ${theme.sz.s12};
    }

    ${theme.focusVisible};
  `,
);

/** Holds a step's main action: under the content on desktop, pinned to the bottom on mobile. */
export const StickyFooter = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s4};
    width: 100%;

    @media (max-width: ${theme.sz.md}) {
      position: fixed;
      inset-inline: 0;
      bottom: 0;
      z-index: ${theme.zi.z1};
      align-items: stretch;
      gap: ${theme.sz.s2};
      padding: ${theme.sz.s3} ${theme.sz.s5} calc(${theme.sz.s4} + env(safe-area-inset-bottom));
      background-color: ${theme.co.blobBackground};
      text-align: center;
    }
  `,
);
